"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderSuggestionsQuerySchema = exports.updateReorderLevelSchema = exports.createReorderLevelSchema = exports.reorderLevelShape = void 0;
const zod_1 = require("zod");
exports.reorderLevelShape = {
    drugId: zod_1.z.string().uuid(),
    locationId: zod_1.z.string().uuid(),
    reorderQty: zod_1.z.number().int().positive(),
};
exports.createReorderLevelSchema = zod_1.z.object(exports.reorderLevelShape);
exports.updateReorderLevelSchema = zod_1.z.object({ reorderQty: zod_1.z.number().int().positive() });
exports.reorderSuggestionsQuerySchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid().optional(),
});
//# sourceMappingURL=reorder-level.schema.js.map